import validator from 'email-validator';
import isValid from 'uk-postcode-validator';

const validate = {
    validateEmail : (email) => {
        return validator.validate(email);
    },
    validateName : (name) => {
        if (name.length < 1) return false
        if (name.length > 40) return false
        for (var i = 0; i < name.length; i++) {
            if (!name.substring(i, i+1) === ""){
                if (!isNaN(name.substring(i, i+1))) {
                    return false;
                } 
            }            
        }
        return true;
    },
    validatePhone : (inputPhone) => {
        //returns false if input is not valid.s
        //returns a formatted phone number is number is valid either as
        //00441582753678 or
        //01582753678
        //spaces removed, '+' changed to 00
        var phone = inputPhone.toString();
        phone = removeSpaces(phone);
        phone = plusToZero(phone);
        if (phone.substring(0,1) != '0') {return false}
        if (phone.substring(0,2) === '00') {
            if (phone.substring(4, 5) === '0'){
                console.log("doing it", phone);
                var firstHalf = phone.substring(0, 4);
                var secondHalf = phone.substring(5, phone.length);
                phone = "" + firstHalf + secondHalf;
                console.log(phone);
            }
        }
        if (phone.length < 11) {console.log("short"); return false;}
        if (phone.length > 14) {console.log("long"); return false;}
        if (phone.substring(0,1) != '0') {console.log("first char"); return false}
        else {
            if (phone.substring(1,2) != '0') {
                if (phone.length != 11) {console.log("wrong length 11", phone.length); return false}
            }
        }
        if (phone.substring(0,2) === '00') {
            if (phone.length != 14) {console.log("wrong length 14"); return false}    
        }
        return phone;
    },
    validateCompanyName : (companyName) => {
        if (companyName.length < 1) return false;
        if (companyName.length > 100) return false;
        return true;
    },
    validateMessage : (message) => {
        if (message.length < 1) return false;
        if (message.length > 1500) return false;
        return true;
    },
    validatePostcode : (postcode) => {
        return isValid(postcode);
    }
}

const removeSpaces = (inputString) => {
    var newString = inputString;
    newString = newString.replace(/\s+/g, '');
    return newString;
}

const plusToZero = (inputString) => {
    return inputString.replace("+", "00");
}

export default validate;
